// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'server-solid';

export const Component = () => (
  <path d='M20.194 0H4.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 3 1.485v6.37h14.224c.335 0 .527.143.527.479 0 .335-.192.479-.527.479H3v6.896h14.224c.335 0 .527.144.527.48 0 .334-.192.478-.527.478H3v6.37c0 .431.144.766.431 1.054.288.287.623.43 1.054.43h15.709a1.41 1.41 0 0 0 1.054-.43 1.41 1.41 0 0 0 .43-1.054V1.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 20.194 0ZM7.454 4.885H6.45c-.335 0-.479-.144-.479-.479 0-.335.144-.479.48-.479h1.005c.335 0 .479.144.479.48 0 .334-.144.478-.48.478Zm.48 7.328v.096c0 .287-.144.43-.48.43H6.402c-.288 0-.431-.143-.431-.43v-.096c0-.288.143-.432.43-.432h1.055c.335 0 .479.144.479.431Zm-.48 8.38H6.45c-.335 0-.479-.143-.479-.478 0-.335.144-.48.48-.48h1.005c.335 0 .479.145.479.48 0 .335-.144.479-.48.479Z' />
);

export const viewBox = '0 0 25 25';
